const o = "dialog", d = "dialog__panel", a = "dialog__content", t = "dialog__footer", n = "dialog__head", _ = {
  dialog: o,
  dialog__panel: d,
  dialog__content: a,
  dialog__footer: t,
  "dialog__head--no-padding-top": "dialog__head--no-padding-top",
  "dialog__head--no-padding-bottom": "dialog__head--no-padding-bottom",
  "dialog--center": "dialog--center",
  dialog__head: n,
  "dialog__content--no-padding-top": "dialog__content--no-padding-top",
  "dialog__content--no-padding-bottom": "dialog__content--no-padding-bottom",
  "dialog__footer--no-padding-top": "dialog__footer--no-padding-top",
  "dialog__footer--no-padding-bottom": "dialog__footer--no-padding-bottom",
  "dialog--top": "dialog--top"
};
export {
  _ as default,
  o as dialog,
  a as dialog__content,
  t as dialog__footer,
  n as dialog__head,
  d as dialog__panel
};
